import * as cryptoApi from "app/api/cryptoApi";
import { PollingIntervals } from "app/utils/const";
import React, { useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import "./CryptoPendingTransactions.scss";

type TransactionType = {
  status: string;
  amount: number;
  coin: string;
  txHash?: string;
  transactionDate: string;
  actionType: string;
  quantity: number;
};

type TransactionsProps = {
  currentTab: string;
  userCurrency: string;
  tabs: { DEPOSIT: string; WITHDRAWAL: string };
  cryptoFirstTimeWithdrawal: boolean;
};

const CryptoPendingTransactions: React.FC<TransactionsProps> = ({
  currentTab,
  userCurrency,
  tabs,
  cryptoFirstTimeWithdrawal,
}) => {
  const [transactions, setPendingTransactions] = useState([]);
  const filteredTransactions: TransactionType[] =
    transactions.length > 0
      ? transactions.filter((t: TransactionType) => {
          return t.actionType === currentTab;
        })
      : [];

  useEffect(() => {
    const fetchPendingTransactions = async () => {
      try {
        const resp = await cryptoApi.getPendingCryptoTransactions();
        setPendingTransactions(resp.data.statuses);
      } catch (error) {
        console.error("Error fetching transactions: ", error);
      }
    };

    // Initial fetch when the component mounts
    fetchPendingTransactions();

    // Set up the polling interval
    const interval = setInterval(
      fetchPendingTransactions,
      PollingIntervals.CRYPTOPENDING
    );

    // Clean up the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  const getTitleText = () => {
    if (filteredTransactions && filteredTransactions.length === 0) {
      if (currentTab === tabs.WITHDRAWAL) {
        return <FormattedMessage id="no-recent-withdrawals" />;
      } else if (currentTab === tabs.DEPOSIT) {
        return <FormattedMessage id="no-recent-deposits" />;
      }
    } else {
      if (currentTab === tabs.WITHDRAWAL) {
        return <FormattedMessage id="recent-withdrawals" />;
      } else if (currentTab === tabs.DEPOSIT) {
        return <FormattedMessage id="recent-deposits" />;
      }
    }
  };

  return (
    <div className="crypto-pending-transactions">
      {cryptoFirstTimeWithdrawal ? (
        ""
      ) : (
        <h3 className="crypto-pending-transactions__title">{getTitleText()}</h3>
      )}
      <div className="crypto-pending-transactions__transactions">
        {filteredTransactions.map(
          (transaction: TransactionType, index: number) => (
            <div
              key={index}
              className="crypto-pending-transactions__transaction"
            >
              <span>
                <FormattedMessage id="cashier-status" />: {transaction.status}
              </span>
              <span>
                <FormattedMessage id="cashier-amount" />({userCurrency}):{" "}
                {transaction.amount}
              </span>
              <span>
                <FormattedMessage id="cashier-coin" />: {transaction.coin}
              </span>
              <span>
                <FormattedMessage id="cashier-transaction-hash" />:{" "}
                {transaction.txHash || "N/A"}
              </span>
              <span>
                <FormattedMessage id="cashier-transaction-date" />:{" "}
                {new Date(transaction.transactionDate).toLocaleString()}
              </span>
              <span>
                <FormattedMessage id="cashier-quantity" />:{" "}
                {transaction.quantity}
              </span>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  cryptoFirstTimeWithdrawal: state.cashierModel.cryptoFirstTimeWithdrawal,
});

export default connect(
  mapStateToProps,
  null
)(injectIntl(CryptoPendingTransactions));
